// extracted by mini-css-extract-plugin
module.exports = {"header":"WithHistory_header__2Jmkj","container":"WithHistory_container__vq-SC"};